import { useInventoryBySerialNumberListContext } from './Context'
import type { BodyRowConfig, HeaderRowConfig } from '@ztechapps/webui.data-tools'
import { DataTable, MenuHeaderCell, RowNumberBodyCell } from '@ztechapps/webui.data-tools'
import { listFieldConfig } from './constants'
import type { ReactNode } from 'react'
import React from 'react'
import { inventorybyserialnumberQueries } from '@ztechapps/inventorybyserialnumber.common'
import { InlineInput, TagsInlineInput } from '@ztechapps/webui.input'
import type { InventoryBySerialNumber, RouteDef } from '@ztechapps/common.contract'
import { InventoryBySerialNumberStatusEnum, InventoryTypeEnum } from '@ztechapps/common.contract'
import { Link } from 'react-router-dom'
import { useInject, WebuiIocKey } from '@ztechapps/webui.contract'
import { InventoryBySerialNumberStatusSelectInlineInput } from '../Status/InventoryBySerialNumberStatusSelect'
import { InventoryBySerialNumberStatus } from '../Status/InventoryBySerialNumberStatus'

const ListHeader = (props: HeaderRowConfig) => {
  return (
    <>
      <MenuHeaderCell />
      {props._renderDataHeaderCell()}
    </>
  )
}

const ListRow = (props: BodyRowConfig<InventoryBySerialNumber, Record<keyof typeof listFieldConfig, ReactNode>>) => {
  const productionRoute = useInject<RouteDef>(WebuiIocKey.routes.workOrderItem)
  const adjustmentRoute = useInject<RouteDef>(WebuiIocKey.routes.adjustmentItem)
  const logisticRoute = useInject<RouteDef>(WebuiIocKey.routes.logisticItem)
  const purchaseOrder = useInject<RouteDef>(WebuiIocKey.routes.purchaseOrderItem)

  const selectedRoute = {
    [InventoryTypeEnum.Build]: productionRoute.altPath({ _id: props?.transactionRef }),
    [InventoryTypeEnum.BuildConsumption]: productionRoute.altPath({ _id: props?.transactionRef }),
    [InventoryTypeEnum.Adjustment]: adjustmentRoute.altPath({ _id: props?.transactionRef }),
    [InventoryTypeEnum.Logistic]: logisticRoute.altPath({ _id: props?.transactionRef }),
    [InventoryTypeEnum.Purchase]: purchaseOrder.altPath({ _id: props?.transactionRef }),
  }

  return (
    <>
      <RowNumberBodyCell {...props} />

      {props._renderDataBodyCell({
        batchCode: <Link to={selectedRoute[props?.transactionType]}>{props?.batchCode}</Link>,
        transactionRef: <Link to={selectedRoute[props?.transactionType]}>{props?.transactionRef}</Link>,

        code: (
          <InlineInput
            name={'code'}
            initialValues={props}
            mutationConfig={inventorybyserialnumberQueries.updateConfig}
            canEdit={props?.status === InventoryBySerialNumberStatusEnum.OnHand}
          />
        ),
        tags: (
          <TagsInlineInput
            name={'tags'}
            initialValues={props}
            mutationConfig={inventorybyserialnumberQueries.updateConfig}
          />
        ),
        remarks: (
          <InlineInput
            name={'remarks'}
            initialValues={props}
            mutationConfig={inventorybyserialnumberQueries.updateConfig}
          />
        ),
        status: (
          <InventoryBySerialNumberStatusSelectInlineInput
            name={'status'}
            initialValues={props}
            mutationConfig={inventorybyserialnumberQueries.updateConfig}
            displayContent={<InventoryBySerialNumberStatus status={props?.status} order={props?.order} />}
            canEdit={false}
          />
        ),
      })}
    </>
  )
}

export const InventoryBySerialNumberListDataTable = () => {
  const { inventorybyserialnumberList } = useInventoryBySerialNumberListContext()

  return (
    <DataTable
      stats="inventory by Serial Numbers"
      name="product-inventory-by-serial-number-v3"
      listResult={inventorybyserialnumberList}
      fields={listFieldConfig}
      head={ListHeader}
      row={ListRow}
      height={{
        topMargin: 350,
      }}
    />
  )
}
